import { useGetStoreDetails } from "@/api/stores/get-store-data";
import { useGetStoreOwnerDetails } from "@/api/stores/get-store-owner-data";
import PageWrapper from "@/components/layout/page-wrapper";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useParams } from "react-router";

const StoreDetails = () => {
    const { id } = useParams();

    const { data: storeDetails, isLoading } = useGetStoreDetails(id || "");
    const { data: storeUseretails, isLoading: isLoadingOwner } = useGetStoreOwnerDetails(id || "");

    if (isLoading || isLoadingOwner) {
        return <div>Loading...</div>;
    }

    return (
        <PageWrapper pageTitle="Store Details" currentPage="Store Details">
            {/* <div className="flex justify-between items-center mb-4">
                <div className="p-4 shadow-none flex gap-4 items-center ">
                    <div className="w-18 h-18 rounded-full bg-gray-200 flex items-center justify-center p-3 border-2 border-gray-300">
                        <img src="/assets/images/logo/bot-icon.png" />
                    </div>
                    <div>
                        <h2 className="text-2xl font-bold">The Super Cool Store</h2>
                        <p className="text-gray-500">Store URL: https://the-cool-store.com/</p>
                    </div>
                </div>
            </div> */}
            <Card className="p-4 shadow-md">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold mb-4">Store Details</h2>
                    {/* <UpdateStoreInfoForm /> */}
                </div>
                <Separator className="mb-4" />

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm text-gray-700">
                    <div>
                        <p className="text-muted-foreground">Name</p>
                        <p className="font-medium">{storeDetails?.data?.name}</p>
                    </div>
                    <div>
                        <p className="text-muted-foreground">Platform</p>
                        <p className="font-medium">{storeDetails?.data?.platform_type ?? "Not Specified"}</p>
                    </div>
                    <div>
                        <p className="text-muted-foreground">Create At</p>
                        <p className="font-medium">{new Date(storeDetails?.data?.created_at).toLocaleDateString()}</p>
                    </div>

                    {/* <div>
                        <p className="text-muted-foreground">URL</p>
                        <p className="font-medium">https://the-cool-store.com</p>
                    </div> */}

                    <div>
                        <p className="text-muted-foreground">Status</p>
                        {storeDetails?.data?.is_active ? (
                            <Badge variant="outline" className="bg-green-100 text-green-700">
                                Active
                            </Badge>
                        ) : (
                            <Badge variant="outline" className="bg-red-100 text-red-700">
                                Inactive
                            </Badge>
                        )}
                    </div>
                </div>
            </Card>
            <Card className="p-4 shadow-md mt-4">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold mb-4">Store User Details</h2>
                    {/* <StoreUserManage /> */}
                </div>
                <Separator className="mb-4" />
                {storeUseretails?.data?.length > 0 &&
                    storeUseretails?.data?.map((user: any) => (
                        <Card key={user.id} className="p-4 shadow-none mb-4">
                            <div className="flex justify-between items-center">
                                <h2 className="text-sm text-gray-600 font-semibold">{user.name}</h2>
                                <h2 className="text-sm text-gray-600 font-semibold">{user.email}</h2>
                                <h2 className="text-sm text-gray-600 font-semibold capitalize">{user.role.replace("_", " ")}</h2>
                            </div>
                        </Card>
                    ))}
                {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-700">
                    <div>
                        <p className="text-muted-foreground">Owner</p>
                        <p className="font-medium text-blue-600">Rakibul Hasan</p>
                    </div>
                    <div>
                        <p className="text-muted-foreground">Number of Agents Allowed</p>
                        <p className="font-medium">3</p>
                    </div>
                    <div>
                        <p className="text-muted-foreground">Number of Agents Active</p>
                        <p className="font-medium">2</p>
                    </div>
                    <div>
                        <p className="text-muted-foreground">Agent 1</p>
                        <p className="font-medium">Mr. Agent One (agent-one@yopmail.com)</p>
                    </div>

                    <div>
                        <p className="text-muted-foreground">Agent 2</p>
                        <p className="font-medium">Mr. Agent Two (agent-two@yopmail.com)</p>
                    </div>
                </div> */}
            </Card>
            {/* <Card className=" mt-4 mx-auto p-6 shadow-md">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold">Training Documents</h2>
                    <Button variant="outline" className="flex items-center gap-2 rounded-full cursor-pointer">
                        <div className="flex items-center gap-2 p-2">
                            <Edit /> Update Files
                        </div>
                    </Button>
                </div>

                <div className="grid grid-cols-12 text-sm text-gray-600 font-medium border-b pb-2">
                    <div className="col-span-6">Name</div>
                    <div className="col-span-3">File Type</div>
                    <div className="col-span-3">File Size</div>
                </div>

                {documents.map((doc, idx) => (
                    <div key={idx} className="grid grid-cols-12 items-start text-sm py-3 border-b last:border-b-0">
                        <div className="col-span-6">
                            <p className="font-semibold text-black">{doc.id}</p>
                            <p className="text-muted-foreground text-xs mt-1">{doc.address}</p>
                        </div>
                        <div className="col-span-3">{doc.type}</div>
                        <div className="col-span-3">{doc.size}</div>
                    </div>
                ))}
            </Card> */}
        </PageWrapper>
    );
};

export default StoreDetails;
